module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"field":{"sensor_filter":"センサー名で絞り込み"},"group":{"unknown":"不明"},"msg":{"unknown_sensor":"不明なセンサー","no_applicable_sensors":"該当するセンサーがありません"}},"en":{"field":{"sensor_filter":"Filter by sensor name"},"group":{"unknown":"Unknown"},"msg":{"unknown_sensor":"Unknown sensor","no_applicable_sensors":"No matching sensors"}}}')
  delete Component.options._Ctor
}
